import ExplanationPageContainer from './ExplanationPageContainer';

/*
* 해설 화면
*/
export default ExplanationPageContainer;